import { render, staticRenderFns } from "./ApprovedByHO.vue?vue&type=template&id=18dbfd10&scoped=true&lang=pug"
import script from "./ApprovedByHO.vue?vue&type=script&lang=ts"
export * from "./ApprovedByHO.vue?vue&type=script&lang=ts"
import style0 from "./ApprovedByHO.vue?vue&type=style&index=0&id=18dbfd10&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbfd10",
  null
  
)

export default component.exports